import { PostPayload } from "../../../model/http-crud-models";
import { OrganizationKeyName } from "../../../model/Organization";
import { UploadImage } from "../../../service/api-response/UploadImage";
import { httpClient, uploadImageAndGetCdnUrl } from "../../../service/http";
import { Organization } from "../model/OrganizationSuccessResponse";

export const organizationHttp = {
  getOrganization: async (organizationKeyName?: OrganizationKeyName) => {
    const data = await httpClient<{ data: Organization }>({
      url: `/organizations/${organizationKeyName}`,
      method: "GET",
    });
    return data.data;
  },

  // No id so using PostPayload
  updateOrganization: async ({
    organizationKeyName,
    data,
  }: PostPayload<Organization>) => {
    return httpClient<{}>({
      url: `/organizations/${organizationKeyName}`,
      method: "PUT",
      data,
    });
  },

  createOrganization: async ({ data }: PostPayload<Organization>) => {
    return httpClient<{}>({
      url: `/management/organizations`,
      method: "POST",
      data,
    });
  },

  uploadOrganizationReceiptImage: async (params: UploadImage) => {
    return uploadImageAndGetCdnUrl({
      ...params,
      apiRoute: "organization-logo",
    });
  },
};
